import React from "react";
import SidebarContainer from "./SidebarContainer";
import TopbarContainer from "./TopbarContainer";
import CanvasContainer from "./CanvasContainer";
import json from '../sample.json';
import { connect } from 'react-redux'
import { getProjectData, setProjectError, openGallery,imageData,selectTool, getRosterToken, expandCollapseSideMenu } from "../actions/wizard";
import ErrorPopup from '../components/ErrorPopup';
import InputModal from "components/InputModal";
import Gallery from "components/Gallery";
import { showSnackbar } from "utils/snackbar";
import AnnotationControls from "./AnnotationControls";
import {ReactComponent as ExpandIcon} from '../assets/icons/expand.svg';
import {ReactComponent as CollapseIcon } from '../assets/icons/collapse.svg';
import { stripBrigadeSegment } from '../utils/profile';

class DrawingWizard extends React.Component<any, any>{
    constructor(props) {
        super(props);
        this.state = {
            pageDetails: {},
            customerDetails: {},
            pageType: ""
        }

    }
    componentDidMount() {
        let url = window.location.href;
        let urlArr = stripBrigadeSegment(url.split('/'));
        let projectId = urlArr[urlArr.length - 1];
        if(urlArr.length ===6){
            localStorage.setItem('access_token', projectId);
            url = url.replace(projectId, "");
            url = url.replace(/\/$/, "");
            window.location.href = url;
            return;
        }
        this.props.getRosterToken()
        if(urlArr.length === 5 )
            projectId = urlArr[urlArr.length - 2];
        projectId = projectId.replace('/', '');
        this.props.getProjectData({ projectId });
    }
    handleErrorPopupClose = ()=>{
        this.props.setProjectError({error: ""});
    }
    handleAddGalleryImage = (urlArr) =>{
        urlArr.map(url => {
            this.props.imageData(url);
            return url;
        })
        this.props.openGallery(false);
        showSnackbar("Images Added To Canvas SuccessFully");
    }
    handleGalleryClose = () =>{
        this.props.openGallery(false);
    }
    render() {
        const { projectError,isDqcDataPresent ,exportDrawingStatus,dqcUpdateMode,isGalleryOpen,roomImages, hideSidebar} = this.props;
        const sideOffset = hideSidebar ? '50px' : '300px';
        const annoteSideOffset = '250px';
        // const rightSideOffset = '200px';
        // const errorDivHeight = '120px';
        const topOffSet = '90px';
        const widthCalc = `calc(100% - ${sideOffset})`;
        //const heightCalc = `calc(100% - ${previewMode ==='disabled'?topOffSet:topOffSet+errorDivHeight})`;
        const heightCalc = `calc(100% - ${topOffSet})`;
        const CanvasContainerStyle = {
            position: 'fixed',
            top: topOffSet,
            left: sideOffset,
            width: widthCalc,
            height: heightCalc,
            backgroundColor: '#f8f8f8',
            maxHeight: heightCalc,
            overflow: 'auto'
        };
        return (
            <div>

                <TopbarContainer
                    height={topOffSet}
                />
                <div className="sidebar_expand_div" style={{ left: sideOffset }} onClick={() => this.props.expandCollapseSideMenu(!hideSidebar)}> {hideSidebar ? <ExpandIcon /> : <CollapseIcon /> } </div>
                <SidebarContainer height={heightCalc} width={sideOffset}  />
                <CanvasContainer style={CanvasContainerStyle} customerDetails={json.customer_details} />
                {
                     projectError && projectError.length ? <ErrorPopup msg={projectError} handleClose={this.handleErrorPopupClose} /> : ""
                }
                {
                    this.props.layeringEnabled && (this.props?.pageDetails?.pageNumber || 1) && <AnnotationControls pn={this.props?.pageDetails?.pageNumber || 1}></AnnotationControls>
                }
                {
                    ( exportDrawingStatus==='pending' && !isDqcDataPresent) || (dqcUpdateMode)? <InputModal/> : ""
                }
                {
                    isGalleryOpen &&  <Gallery imageurlsList={roomImages}  handleAddGalleryImage={this.handleAddGalleryImage} handleClose={this.handleGalleryClose}></Gallery>
                }
                
                {/*
            <RightSideBar width ={rightSideOffset} />
*/}
            <div id="snackbar">Some text some message..</div>
            </div>
        )
    }
}
export default connect(
    (state: any) => ({
        previewMode: state.wizard.previewMode,
        exportDrawingStatus: state.wizard.exportDrawingStatus,
        projectError: state.wizard.error,
        fabricInstanceSelector: state.wizard.fabricInstanceSelector,
        isDqcDataPresent:state.wizard.isDqcDataPresent,
        dqcUpdateMode:state.wizard.dqcUpdateMode,
        isGalleryOpen: state.wizard.isGalleryOpen,
        roomImages: state.wizard.roomImages,
        layeringEnabled:  state.wizard.layeringEnabled,
        pageDetails:state.wizard.pageDetails,
        hideSidebar: state.wizard.hideSidebar
    }),
    {
        getProjectData,
        setProjectError,
        openGallery,
        imageData,
        selectTool,
        getRosterToken,
        expandCollapseSideMenu
    }
)(DrawingWizard);